import { ISoilAnalysis, SsmClassification } from "../../omnia"
import { getSsmAttributesGrouped } from "../../ssm/attrs"
import { SsmAttribute, SsmAttributeGroup } from "../../ssm/types"
import { validateAnalysis } from "./edit"
import { AttributeComment } from "./types"

const groupNames: { [key in SsmAttributeGroup]: string } = {
    std: "Standard analysis",
    soil: "Soil properties",
    total: "Total elements",
    available: "Available elements",
    additional: "Additional elements"
}

export function getAttributeGroups(classification: SsmClassification[], analysis: ISoilAnalysis) {

    const groups = getSsmAttributesGrouped(classification)

    const attrs = Object.keys(groups).map(k => groups[k])

    validateAnalysis(analysis, attrs)

    return setupComments(groups, analysis)

}

function setupComments(groups: ReturnType<typeof getSsmAttributesGrouped>, analysis: ISoilAnalysis) {

    const interpretations: Map<string, AttributeComment> = new Map((analysis?.Interpretations || []).map(a => [
        a.PropertyName,
        getComment(a.PropertyName, a.Comment, false)
    ]))

    const result = Object.keys(groups).map((key: SsmAttributeGroup) => ({
        key,
        text: groupNames[key] as string,
        attributes: (groups[key] as SsmAttribute[]).map(a => ({
            ...a,
            comment: interpretations.get(a.property) || getComment(a.property, undefined, true)
        }))
    }))

    return result

    function getComment(property: string, text: string, useDefault: boolean) {
        return {
            property,
            text,
            useDefault
        }
    }

}
